import { useState } from "react";
import { Send, Check } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubscribed, setIsSubscribed] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email) {
      toast.error("Please enter your email address");
      return;
    }

    setIsSubmitting(true);

    try {
      await axios.post(`${API}/newsletter/subscribe`, { email });
      setIsSubscribed(true);
      toast.success("Welcome! Check your inbox for a confirmation email.");
      setEmail("");
    } catch (error) {
      if (error.response?.status === 400) {
        toast.error("This email is already subscribed!");
      } else {
        console.error("Error subscribing:", error);
        toast.error("Something went wrong. Please try again.");
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="bg-sky-700 rounded-2xl p-8" data-testid="newsletter-section">
      <div className="flex flex-col lg:flex-row items-center justify-between gap-6">
        {/* Text */}
        <div className="text-center lg:text-left">
          <h3 className="text-2xl font-bold text-white mb-2">
            Get Exclusive Travel Deals
          </h3>
          <p className="text-sky-200">
            Subscribe to our newsletter and be the first to know about special offers and new destinations.
          </p>
        </div>

        {/* Form */}
        {isSubscribed ? (
          <div className="flex items-center gap-3 bg-sky-600 rounded-xl px-6 py-4">
            <div className="w-10 h-10 bg-green-500 rounded-full flex items-center justify-center">
              <Check className="text-white" size={24} />
            </div>
            <div className="text-white">
              <p className="font-semibold">You're subscribed!</p>
              <p className="text-sky-200 text-sm">Check your inbox for confirmation</p>
            </div>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 w-full lg:w-auto">
            <Input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="bg-white border-0 text-sky-900 placeholder:text-sky-400 min-w-[280px]"
              data-testid="newsletter-email-input"
            />
            <Button
              type="submit"
              disabled={isSubmitting}
              className="bg-yellow-400 hover:bg-yellow-500 text-sky-900 font-semibold whitespace-nowrap"
              data-testid="newsletter-submit-btn"
            >
              {isSubmitting ? (
                "Subscribing..."
              ) : (
                <>
                  <Send size={18} className="mr-2" />
                  Subscribe
                </>
              )}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
